import React, { useEffect } from "react";
import { Button, List, ListItem, ListItemText, ListItemIcon, IconButton } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { Row, Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { openAlert } from "simple-react-alert";
import { getV2, delV2 } from "../../api/axiosV2";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

const CodigosCuponesList = (props) => {
  const [codigoCupones, setCodigoCupones] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
  });

  useEffect(() => {
    getCodigoCupones(pagination.page, pagination.limit);
  }, []);

  const getCodigoCupones = (page, limit) => {
    getV2("/admin/codigo-cupones?page=" + page + "&limit=" + limit).then(
      (response) => {
        setCodigoCupones(response.data.data);
        setPagination({
          page: response.data.page,
          limit: response.data.limit,
          total: response.data.total,
          totalPages: Math.ceil(response.data.total / response.data.limit),
        });
      }
    );
  };

  const eliminarCodigoCupon = (id, event) => {
    event.stopPropagation(); // Prevent triggering the list item click
    if (!window.confirm("¿Está seguro que desea eliminar este código de cupón?")) {
      return;
    }

    delV2("/admin/codigo-cupones/", id).then(() => {
      openAlert({
        message: "Código de cupón eliminado con éxito",
        type: "success"
      });
      // Reload the current page
      getCodigoCupones(pagination.page, pagination.limit);
    }).catch(() => {
      openAlert({
        message: "Error al eliminar código de cupón",
        type: "danger"
      });
    });
  };

  const handleChangePage = (event, value) => {
    setPagination({ ...pagination, page: value });
    getCodigoCupones(value, pagination.limit);
  };

  const renderCodigoCupones = () => {
    return (
      <List
        component="nav"
        aria-label="main mailbox folders"
        style={{ maxHeight: "400px", overflow: "auto" }}
      >
        {codigoCupones.map((codigoCupon, key) => {
          return (
            <ListItem
              button
              onClick={() => props.history.push("/cupones/codigos/editar/" + codigoCupon.id)}
              key={key}
            >
              <ListItemText
                primary={codigoCupon.codigo + " - Cupón: " + codigoCupon.cupon.nombre}
              />
              <ListItemIcon>
                <EditIcon />
              </ListItemIcon>
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={(e) => eliminarCodigoCupon(codigoCupon.id, e)}
                color="secondary"
              >
                <DeleteIcon />
              </IconButton>
            </ListItem>
          );
        })}
      </List>
    );
  };

  return (
    <Row xs={{ span: 12, offset: 2 }} className="justify-content-md-center rowContainer">
      <Col xs={8}>
        <Button
          size="large"
          variant="contained"
          className="ml-2"
          onClick={() => props.history.push("/cupones/codigos/nuevo")}
        >
          Agregar nuevo código
        </Button>
        {renderCodigoCupones()}
        <Pagination
          count={pagination.totalPages}
          color="primary"
          onChange={handleChangePage}
          page={pagination.page}
          className="mt-2"
        />
      </Col>
    </Row>
  );
};

export default withRouter(CodigosCuponesList);
